export enum ESberIntegrationApiUrl {
  directoryRegions = '/api/sberbank-integration/regions',
}
